import React, { useState } from 'react';

function useStyles() {
  const [styles] = useState(
    {
      // LINK
      '--mdc-theme-primary': '#1d2238',
      '--mdc-theme-secondary': '#1d2238',
      '--logo-color': '8092CF',
      '--logo-color-on-dark': 'ffffff',
      '--logo-color-muted': 'D3D3D3',
      '--share-buttons-bg': '#aeaeae'

      // ETH
      /*'--mdc-theme-primary': '#29526D',
      '--mdc-theme-secondary': '#668aa0',
      '--logo-color': '668aa0',
      '--logo-color-on-dark': 'ffffff',
      '--logo-color-muted': 'D3D3D3'*/

      // MATIC
      /*'--mdc-theme-primary': '#6D256F',
      '--mdc-theme-secondary': '#A46FA6',
      '--logo-color': 'A46FA6',
      '--logo-color-on-dark': 'ffffff',
      '--logo-color-muted': 'D3D3D3'*/

       // FIL
       /*'--mdc-theme-primary': '#01565E',
       '--mdc-theme-secondary': '#029BA9',
       '--logo-color': '029BA9',
       '--logo-color-on-dark': 'ffffff',
       '--logo-color-muted': 'D3D3D3'*/

        // CHZ
        /*'--mdc-theme-primary': '#56000F',
        '--mdc-theme-secondary': '#AC0A27',
        '--logo-color': 'AC0A27',
        '--logo-color-on-dark': 'ffffff',
        '--logo-color-muted': 'D3D3D3'*/

         // LUNA
         /*'--mdc-theme-primary': '#021635',
         '--mdc-theme-secondary': '#093371',
         '--logo-color': '093371',
         '--logo-color-on-dark': 'ffffff',
         '--logo-color-muted': 'D3D3D3'*/

         // BTC
         /*'--mdc-theme-primary': '#C3710C',
         '--mdc-theme-secondary': '#F6941C',
         '--logo-color': 'F6941C',
         '--logo-color-on-dark': 'ffffff',
         '--logo-color-muted': 'D3D3D3'*/

         // ETC
         /*'--mdc-theme-primary': '#006306',
         '--mdc-theme-secondary': '#0D8415',
         '--logo-color': '0D8415',
         '--logo-color-on-dark': 'ffffff',
         '--logo-color-muted': 'D3D3D3'*/
    }
  );

  return [styles];
}

export default useStyles;